export const filterOptions = [
  { name: "New Firmware", value: "new" },
  { name: "Old Firmware", value: "old" },
  { name: "Old & New Firmware", value: "both" },
  { name: "Process ID", value: "processId" },
];
